import React from 'react'
import { isNotSuccessful } from '../../../../hooks/useQuery'
import SelectFieldFilter from '../../../molecules/filters/SelectFieldFilter'
import useUser from '../../../../hooks/services/useUser'
import useSearchParams from '../../../../hooks/useSearchParams'
import useUserPermission from '../../../../hooks/useUserPermission'
import { useAuth } from '../../../molecules/Auth'

const CollaboratorFilter = () => {
  const { canSeeInstitutionFilter } = useUserPermission('statistics')
  const { getCollaborator } = useUser()
  const { user } = useAuth()
  const searchParams = useSearchParams()
  const paramsInstitutionId = searchParams.get('attended_request_institution_id')
  const { data: users, status } = getCollaborator({
    institutionId: canSeeInstitutionFilter ? paramsInstitutionId : user.institution_id
  })

  const isDisabled = canSeeInstitutionFilter ? !paramsInstitutionId : false

  return (
    <>
      <SelectFieldFilter
        className="w-full"
        label="Colaborador asignado"
        name="attended_collaborator"
        margin="none"
        size="full"
        emptyLabel="Selecciona un colaborador"
        options={users || []}
        disabled={isDisabled || isNotSuccessful(status)}
      />
    </>
  )
}

export default CollaboratorFilter
